<template>
  <v-container fluid class="fill-height color-background">
    <v-row class="pa-5" justify="space-between">
      <h1 class="text--secondary">Lista de Inscrições</h1>
      <Btn
        class="ma-2"
        icon="mdi-arrow-left"
        label="Voltar para Login"
        large
        @click="$emit('show-login')"
      />

      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Busca"
              hide-details
              clearable
            ></v-text-field>
          </v-card-text>
          <v-tabs v-model="tab" grow @change="onChangeTab">
            <v-tab key="vagaIntegral" href="#vagaIntegral"
              >Vaga Integral (PRÉ)</v-tab
            >
            <v-tab key="plantaoFerias" href="#plantaoFerias"
              >Plantão de Férias</v-tab
            >
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item value="vagaIntegral" key="vagaIntegral">
              <table-vaga-integral :search="search" />
            </v-tab-item>
            <v-tab-item value="plantaoFerias" key="plantaoFerias">
              <table-plantao-ferias :search="search" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Btn from "@/components/Btn";
import TableVagaIntegral from "./components/TableVagaIntegral";
import TablePlantaoFerias from "./components/TablePlantaoFerias";

export default {
  name: "cadastros-deferidos",

  components: {
    Btn,
    TableVagaIntegral,
    TablePlantaoFerias,
  },

  props: {
    tipoConsulta: {
      type: String,
      default: "vagaIntegral",
    },
  },

  data: () => ({
    tab: "",
    loading: false,
    search: "",
    dadosRelatorio: [],
    tableHeaders: [
      {
        text: "Protocolo",
        align: "center",
        sortable: true,
        value: "protocolo",
      },
      {
        text: "Nome",
        align: "center",
        sortable: true,
        value: "nome",
      },
    ],
    tableFooterProps: {
      "items-per-page-options": [10, 50, 100, -1],
      "items-per-page-text": "Inscrições por página",
      "page-text": "{0}-{1} de {2}",
    },
  }),

  mounted() {
    this.tab = this.tipoConsulta;
  },

  methods: {
    onChangeTab() {
      this.search = "";
    },
  },
};
</script>

<style scoped>
.color-background {
  background-color: #e8eaf6;
}
</style>
